import { apiFetch } from '../utils/apiFetch';
import { API_CONFIG } from '../constants';
import type { ActiveQRCodeResponse } from '../dtos/qr';

export type { ActiveQRCodeResponse } from '../dtos/qr';

export class StartSessionError extends Error {
  status: number;
  errorCode?: string;
  payload?: unknown;

  constructor(
    message: string,
    status: number,
    errorCode?: string,
    payload?: unknown
  ) {
    super(message);
    this.name = 'StartSessionError';
    this.status = status;
    this.errorCode = errorCode;
    this.payload = payload;
  }
}

export async function getActiveQRCode(
  podId: number | string
): Promise<ActiveQRCodeResponse> {
  const response = await apiFetch({
    url: API_CONFIG.ENDPOINTS.ACTIVE_QR(podId),
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch active QR code: ${response.status}`);
  }

  return response.json();
}

export async function regenerateQRCode(
  podId: number | string
): Promise<ActiveQRCodeResponse> {
  const response = await apiFetch({
    url: API_CONFIG.ENDPOINTS.REGENERATE_QR(podId),
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error(`Failed to regenerate QR code: ${response.status}`);
  }

  return response.json();
}

//This api is only used for mock login
export async function startSession(qrToken: string): Promise<unknown> {
  const response = await apiFetch({
    url: API_CONFIG.ENDPOINTS.START_SESSION_QR,
    method: 'POST',
    body: {
      qrToken,
      patientId: 2, // Default mock patient ID
    },
  });

  if (!response.ok) {
    const raw = await response.text().catch(() => '');
    let payload: unknown = raw;
    let errorCode: string | undefined;

    if (raw) {
      try {
        const parsed = JSON.parse(raw) as { errorCode?: string };
        payload = parsed;
        errorCode = parsed.errorCode;
      } catch {
        // Keep raw text payload for non-JSON responses.
      }
    }

    throw new StartSessionError(
      `Start session failed (${response.status})${errorCode ? ` [${errorCode}]` : ''}`,
      response.status,
      errorCode,
      payload
    );
  }

  return response.json();
}
